import { Link } from "react-router-dom";
import LogoMark from "@/components/LogoMark";
import StripeRule from "@/components/StripeRule";
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function subscribe(e) {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. Thanks for joining HOFA.");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <footer className="bg-ink text-paper pt-20 pb-8" id="site-footer">
      <div className="max-w-[1140px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-12 mb-14">
          <div>
            <Link to="/" className="flex items-center gap-3 no-underline text-paper">
              <LogoMark size={40} />
              <span className="font-display text-[22px]">HOFA</span>
            </Link>
            <p className="mt-4 max-w-[40ch] text-[15px] text-paper/75">
              Hope For All Organizations — transforming lives and building stronger communities through the ERSEH framework since 2015.
            </p>
          </div>
          <div>
            <h3 className="text-mango text-[18px] mb-4 font-display">Contact</h3>
            <ul className="list-none p-0 space-y-1.5 text-[15px] text-paper/75">
              <li><strong className="text-paper">Liberia:</strong> +231 770 758 626</li>
              <li>+231 77 659 5045</li>
              <li><strong className="text-paper">USA:</strong> +1 603 728 9072</li>
              <li>Mango Town, Brewerville, Liberia</li>
              <li>Essex Junction, Vermont, USA</li>
            </ul>
          </div>
          <div>
            <h3 className="text-mango text-[18px] mb-4 font-display">Explore</h3>
            <ul className="list-none p-0 space-y-1.5 text-[15px]">
              <li><Link to="/about" className="text-paper/75 no-underline hover:text-mango">About HOFA</Link></li>
              <li><Link to="/programs" className="text-paper/75 no-underline hover:text-mango">Programs</Link></li>
              <li><Link to="/esafc" className="text-paper/75 no-underline hover:text-mango">ESAFC Football Club</Link></li>
              <li><Link to="/news" className="text-paper/75 no-underline hover:text-mango">News & Films</Link></li>
              <li><Link to="/get-involved" className="text-paper/75 no-underline hover:text-mango">Get Involved</Link></li>
              <li><Link to="/contact" className="text-paper/75 no-underline hover:text-mango">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-mango text-[18px] mb-4 font-display">Stay woven in</h3>
            <p className="text-[14.5px] text-paper/70 mb-3">
              Quarterly updates from Mango Town — no spam, ever.
            </p>
            <form onSubmit={subscribe} className="flex gap-2 flex-col" data-testid="newsletter-form">
              <input
                type="email"
                required
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="newsletter-email-input"
                className="w-full rounded-full px-4 py-2.5 bg-paper/10 border border-paper/25 text-paper placeholder:text-paper/40 focus:outline-none focus:border-mango"
              />
              <button
                type="submit"
                disabled={submitting}
                data-testid="newsletter-submit-btn"
                className="bg-mango text-palm-deep font-bold rounded-full px-5 py-2.5 hover:shadow-lg transition disabled:opacity-60"
              >
                {submitting ? "Subscribing…" : "Subscribe"}
              </button>
            </form>
            <p className="text-[11.5px] text-paper/45 mt-2">
              You'll receive quarterly HOFA updates. Unsubscribe any time from the link in every email.
            </p>
          </div>
        </div>
        <div className="border-t border-paper/15 pt-6 flex flex-wrap justify-between gap-4 text-[13.5px] text-paper/55">
          <span>© 2026 Hope For All Organizations (HOFA). All rights reserved.</span>
          <span>Brewerville, Montserrado County, Liberia · District 17</span>
        </div>
      </div>
      <StripeRule className="mt-8" />
    </footer>
  );
}
